const STATUS_CLASS: Record<string, string> = {
  ACTIVE: "badge-active",
  PENDING: "badge-pending",
  PENDING_INVITE: "badge-pending",
  AWAITING_VERIFICATION_CODE: "badge-pending",
  CANCELED: "badge-canceled",
  NEEDS_MANUAL: "badge-needs-manual",
  MFA_REQUIRED: "badge-warn",
  SUSPICIOUS_REJECTED: "badge-warn",
};

export function StatusBadge({ status }: { status: string }) {
  const cls = STATUS_CLASS[status] ?? "badge-pending";
  return <span className={`badge ${cls}`}>{status}</span>;
}
